import Swiper from 'swiper';
import { Grid, Navigation, Pagination } from 'swiper/modules';

export default function setCarousel() {
  const productsCarousel = document.querySelectorAll('[data-products-carousel]');

  productsCarousel.forEach((section) => {
    const carousel = section.querySelector('.swiper');
    const pagination = section.querySelector('.swiper-pagination');
    const mobileGridRows = Number(section.dataset.mobileGridRows) || 1;

    const closestParent = section.closest('.carousel');

    const next = window.mobile ? closestParent.querySelector('.swiper-button-next') : section.querySelector('.swiper-button-next');
    const prev =  window.mobile ? closestParent.querySelector('.swiper-button-prev') : section.querySelector('.swiper-button-prev');

    if (carousel) {
      const swiper = new Swiper(carousel, {
        modules: [Grid, Navigation, Pagination],
        slidesPerView: mobileGridRows > 1 ? 2 : 1.3,
        spaceBetween: 8,
        grid: {
          rows: mobileGridRows,
          fill: 'row',
        },
        watchOverflow: true,
        speed: 1000,
        navigation: {
          nextEl: next,
          prevEl: prev,
        },
        breakpoints: {
          768: {
            slidesPerView: 3,
            spaceBetween: 24,
            grid: {
              rows: 1,
            },
          },
          992: {
            slidesPerView: 4,
            spaceBetween: 24,
          },
          1440: {
            slidesPerView: 4,
            spaceBetween: 24,
          },
        },
        pagination: {
          el: pagination,
          type: 'bullets',
          clickable: true,
        },
      });
    }
  });
}
